"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdentifierPath = exports.extractAssetAgnosticProperties = void 0;
var _objects = require("../../utils/objects");
var VERSION_AGNOSTIC_PROPERTIES = ['type', 'name', 'description', 'icon', 'groupId', 'assetId', 'organization'];
var extractAssetAgnosticProperties = exports.extractAssetAgnosticProperties = function extractAssetAgnosticProperties(asset) {
  return _objects.pick.apply(void 0, [asset].concat(VERSION_AGNOSTIC_PROPERTIES));
};
var getIdentifierPath = exports.getIdentifierPath = function getIdentifierPath(props) {
  return [props.domain, props.groupId, props.assetId, props.version, props.minorVersion, props.status].reduce(function (accum, current) {
    if (!current) {
      return accum;
    }
    if (typeof current === 'string') {
      return "".concat(accum ? "".concat(accum, ":") : '').concat(current);
    }
    return "".concat(accum ? "".concat(accum, ":") : '').concat(current.toString());
  }, '');
};
//# sourceMappingURL=utils.js.map